import { render } from "./InsuranceCompanyManage.vue?vue&type=template&id=7e532888"
import script from "./InsuranceCompanyManage.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyManage.vue?vue&type=script&lang=js"

import "./InsuranceCompanyManage.vue?vue&type=style&index=0&id=7e532888&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__